import React from 'react';

import { useAppDispatch, useAppSelector } from 'segments/hooks';

import { changeGroupsActiveModal, selectGroupsActiveModal, useGetGroupsListQuery } from 'features/groups';

import { AddUser } from './components/AddUser';
import CreateModal from './components/CreateModal';
import EditModal from './components/EditModal';

type Props = {
  selectedGroupeId?: number;
};

export const Modals = ({ selectedGroupeId }: Props) => {
  const {
    groupsList,
    isGroupsLoading
  } = useGetGroupsListQuery(undefined, {
    selectFromResult: ({ data, isLoading }) => ({
      groupsList: data?.items ?? [],
      isGroupsLoading: isLoading
    })
  });
  const activeModal = useAppSelector(selectGroupsActiveModal);
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(changeGroupsActiveModal(null));

  if (isGroupsLoading) {
    return;
  }

  const selectedGroupe = groupsList
    .find((groupe) => groupe.id === selectedGroupeId);

  return (
    <>
      <EditModal
        key={`editGroupe${selectedGroupeId}`}
        isModalOpen={activeModal === 'edit-groupe-modal' && selectedGroupeId !== undefined}
        handleCancel={closeModal}
        data={selectedGroupe === undefined
          ? undefined
          : {
            id: selectedGroupe.id,
            coachId: selectedGroupe.coachId,
            name: selectedGroupe.name,
            priceIndividual: selectedGroupe.priceIndividual,
            price: selectedGroupe.price,
            usersId: selectedGroupe.users.map((user) => user.id)
          }}
      />
      <CreateModal
        key={'createGroupe'}
        isModalOpen={activeModal === 'create-groupe-modal'}
        handleCancel={closeModal}
      />
      <AddUser
        key={'addUserToGroupe'}
        handleCancel={closeModal}
        isModalOpen={activeModal === 'add-user-groupe'}
      />
    </>
  );
};
